/// <reference path="../../Common/Base/SiteEntityDialog.ts" />

namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    @Serenity.Decorators.panel()
    export class SecurityValueDialog extends SiteEntityDialog<SecurityValueRow, any> {
        protected getFormKey() { return SecurityValueForm.formKey; }
        protected getIdProperty() { return SecurityValueRow.idProperty; }
        protected getLocalTextPrefix() { return SecurityValueRow.localTextPrefix; }
        protected getNameProperty() { return SecurityValueRow.nameProperty; }
        protected getService() { return SecurityValueService.baseUrl; }

        protected form = new SecurityValueForm(this.idPrefix);

    }
}